var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"disable",attrs:{"id":"overlay"}},[(_vm.detailed)?_c('div',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.$t("disabled.text"))+"\n    "),(!_vm.disabled)?_c('b-btn',{attrs:{"to":_vm.btnLink,"variant":"primary","block":""}},[_vm._v("\n      "+_vm._s(_vm.$t('actions.activate'))+"\n    ")]):_vm._e()],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29880050","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DisabledOverlay.vue
// module id = 943
// module chunks = 1